import { v4 as uuidv4 } from 'uuid';
import { getTripsApiUrl } from '../selectors/selectors';
import { getLimoTripTitle, getTripIcons } from '../helpers/helpers';
import {
  APPLICATION_JSON, CLIENT_ID, POST, INCLUDE,
} from '../constants/constants';

export default {
  fetch: ({ type, locale, correlationId }, action, state) => ({
    url: `${getTripsApiUrl(state)}?type=${type}`,
    opts: {
      method: POST,
      credentials: INCLUDE,
      timeout: 30e3,
      headers: {
        'Content-Type': APPLICATION_JSON,
        'x-correlation-id': correlationId || uuidv4(),
        'x-client-id': CLIENT_ID,
        'x-locale': locale,
      },
    },
  }),

  transformData: (data) => {
    const tripData = data?.bookings && data?.bookings?.map((trip) => ({
      id: trip?.tripId,
      title: `${trip?.type === 'Limo' ? getLimoTripTitle(trip?.destination) : `Trip to ${trip?.destination}`}`,
      date: `${trip?.startDateTime?.isoDateTime} & ${trip?.endDateTime?.isoDateTime}`,
      bookings: getTripIcons(trip),
      ...trip,
    }));
    return { ...data, bookings: tripData };
  },
};
